import React, { Component } from 'react'
import Phones from '../lib/phones-service'
import FlashMessage from 'react-flash-message'

export default class DetailPhone extends Component {
    state = {
        title: "",
        name: "",
        manufacturer: "",
        description: "",
        color: "",
        price: "",
        imageFileName: "",
        screen: "",
        processor: "",
        ram: 0,
        changes: false
    };

    componentDidMount() {
        const { id } = this.props.match.params;
        Phones.getProduct(id)
            .then(data => {
                const { name, manufacturer, description, color, price, imageFileName, screen, processor, ram } = data
                this.setState({
                    title: name,
                    name: name,
                    manufacturer: manufacturer,
                    description: description,
                    color: color,
                    price: price,
                    imageFileName: imageFileName,
                    screen: screen,
                    processor: processor,
                    ram: ram
                })
            })
            .catch((error) => {
                this.setState({ getError: true });
                console.error("Error 🔥", error);
            });
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleSubmit = (e) => {
        const { id } = this.props.match.params;
        const {
            name,
            manufacturer,
            description,
            color,
            price,
            imageFileName,
            screen,
            processor,
            ram
        } = this.state;

        Phones.editProduct(id, {
            name, manufacturer, description, color, price, imageFileName, screen, processor, ram
        })
            .then(result => {
                this.props.history.push(`/`);
                this.setState = { changes: true }
            })
            .catch(error => { console.error(error) })
    }

    handleDelete = (e) => {
        const { id } = this.props.match.params;
        Phones.deleteProduct(id)
        .then(result => {
            this.props.history.push(`/`);
        })
        .catch(error => { console.error(error) })
    }

    render() {
        const { name, manufacturer, description, color, price, imageFileName, screen, processor, ram } = this.state
        return (
            <div className="container">
                <h1 className="title is-1">{name}</h1>
                {this.state.changes === false ? null :
                    <FlashMessage duration={5000} persistOnHover={true}>
                        <p>Message</p>
                    </FlashMessage>
                }
                <div className="columns is-desktop">
                    <div className="column">
                        <img alt={name} src={imageFileName} />
                    </div>
                    <div className="column">
                        <h2 className="title is-2">Details</h2>
                        <div className="field">
                            <div className="control">
                                <label>Name</label>
                                <input className="input" value={name} type="text" name="name" onChange={this.handleOnChange} placeholder="Smartphone model name" disabled />
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <label>Manufacturer</label>
                                <input className="input" value={manufacturer} type="text" name="manufacturer" onChange={this.handleOnChange} placeholder="Brand or manufacturer" disabled />
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <label>Description</label>
                                <input className="input" value={description} type="text" name="description" onChange={this.handleOnChange} placeholder="Description and details" />
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <label>Color</label>
                                <input className="input" value={color} type="text" name="color" onChange={this.handleOnChange} placeholder="Smartphone color" />
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <label>Screen</label>
                                <input className="input" value={screen} type="text" name="screen" onChange={this.handleOnChange} placeholder="Screen" />
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <label>Processor</label>
                                <input className="input" value={processor} type="text" name="processor" onChange={this.handleOnChange} placeholder="Processor" />
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <label>Memory</label>
                                <input className="input" value={ram} type="text" name="ram" onChange={this.handleOnChange} placeholder="RAM Memory" />
                            </div>
                        </div>
                        <div className="field">
                            <div className="control">
                                <label>Price</label>
                                <input className="input" value={price} type="number" name="price" onChange={this.handleOnChange} placeholder="Price" />
                            </div>
                        </div>
                        <div className="buttons">
                            <button className="button is-primary" onClick={() => this.handleSubmit()}>Modify</button>
                            <button className="button is-danger" onClick={() => this.handleDelete()}>Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
